// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const pending = "StatusCopy__pending__u+7Ro";
export const confirmed = "StatusCopy__confirmed__ycHXs";
export const earned = "StatusCopy__earned__8OlXN";
export const expired = "StatusCopy__expired__3nkOa";
export const statusCopy = "StatusCopy__statusCopy__vSxFB";